import { toKRString } from '../../lib/util/dateFormatter';

export interface ClientSummary {
  readonly id: Id;
  readonly clientSerial: Serial;
  readonly name: Name;
  readonly birthday: Date;
  readonly gender: Gender;
}

export interface ClientSummaryDto {
  readonly id: Id;
  readonly serial: Serial;
  readonly name: Name;
  readonly birth: DateString;
  readonly gender: Gender;
}

export const clientSummaryFromDto = (
  clientSummaryDto: ClientSummaryDto
): ClientSummary => {
  return {
    ...clientSummaryDto,
    clientSerial: clientSummaryDto.serial,
    birthday: new Date(clientSummaryDto.birth),
  };
};

export interface Client extends ClientSummary {
  readonly id: Id;
  readonly pregnancy: Pregnancy;
  readonly menstrualDate?: Date;
  readonly nationality: Nationality;
  readonly idNumber?: IdNumber;
  readonly passportNumber?: IdNumber;
  readonly phone: Phone;
  readonly email: Email;
  readonly memo: Memo;
  readonly createdAt: Date;
}

export interface ClientDto {
  readonly id: Id;
  readonly serial: Serial;
  readonly name: Name;
  readonly birth: DateString;
  readonly gender: Gender;
  readonly isPregnant: 't' | 'f';
  readonly menstrualDate?: DateString;
  readonly nationality: Nationality;
  readonly nik: IdNumber;
  readonly email: Email;
  readonly phone: Phone;
  readonly createdAt: DateString;
  readonly memo?: Memo;
}

export const clientFromDto = (clientDto: ClientDto): Client => {
  return {
    ...clientDto,
    clientSerial: clientDto.serial,
    birthday: new Date(clientDto.birth),
    pregnancy: clientDto.isPregnant === 't' ? true : false,
    memo: clientDto.memo ?? '',
    createdAt: new Date(clientDto.createdAt),
    idNumber: clientDto.nationality === 'INDONESIA' ? clientDto.nik : undefined,
    passportNumber:
      clientDto.nationality === 'FOREIGN' ? clientDto.nik : undefined,
    menstrualDate: clientDto.menstrualDate
      ? new Date(clientDto.menstrualDate)
      : undefined,
  };
};

export interface ClientMO {
  id?: Id;
  name?: Name;
  birth?: DateString;
  gender?: Gender;
  isPregnant?: string;
  menstrualDate?: DateString;
  nationality?: Nationality;
  nik?: IdNumber;
  phone?: Phone;
  email?: Email;
  memo?: Memo;
}

export const clientMOFromClient = (client: Client): ClientMO => {
  return {
    id: client.id < 0 ? undefined : client.id,
    name: client.name,
    birth: toKRString(client.birthday),
    gender: client.gender,
    isPregnant: client.pregnancy ? 'true' : 'false',
    nationality: client.nationality,
    nik:
      client.nationality === 'INDONESIA'
        ? client.idNumber
        : client.passportNumber,
    phone: client.phone ?? '',
    email: client.email ?? '',
    memo: client.memo ?? '',
    menstrualDate: client.menstrualDate
      ? toKRString(client.menstrualDate)
      : undefined,
  };
};
